import { render, staticRenderFns } from "./WorkBookMarketingToolkit.vue?vue&type=template&id=97be6de6&scoped=true&"
import script from "./WorkBookMarketingToolkit.vue?vue&type=script&lang=js&"
export * from "./WorkBookMarketingToolkit.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookMarketingToolkit.vue?vue&type=style&index=0&id=97be6de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97be6de6",
  null
  
)

export default component.exports